<ng-template #iconRef>
	<div *ngIf="isFingerPrint && !errorMessage">
		<svg fill="none" height="73" viewBox="0 0 73 73" width="73" xmlns="http://www.w3.org/2000/svg">
			<circle cx="36.5" cy="36.5" fill="#0357EE" fill-opacity="0.1" r="36.5"/>
			<circle cx="36.5" cy="36.5" fill="#0361F0" r="25.5"/>
			<path
				d="M21.8203 32.3867C21.6147 32.3886 21.4124 32.336 21.2337 32.2344C21.1027 32.1607 20.9877 32.0617 20.8954 31.943C20.8031 31.8244 20.7354 31.6885 20.6962 31.5434C20.6571 31.3983 20.6473 31.2468 20.6674 31.0979C20.6875 30.9489 20.7371 30.8055 20.8133 30.6759C22.2819 28.2247 26.7501 22.5034 36.5001 22.5034C40.7254 22.5034 44.4311 23.6132 47.5092 25.8009C50.0427 27.5963 51.4625 29.6285 52.139 30.6073C52.2247 30.7307 52.285 30.87 52.3161 31.017C52.3473 31.164 52.3487 31.3158 52.3203 31.4634C52.2919 31.6109 52.2343 31.7513 52.1508 31.8763C52.0673 32.0012 51.9597 32.1082 51.8343 32.191C51.5779 32.3604 51.2656 32.4234 50.9636 32.3665C50.6615 32.3097 50.3935 32.1374 50.2164 31.8863C48.9923 30.1259 45.2599 24.7695 36.5001 24.7695C27.9498 24.7695 24.0841 29.6986 22.825 31.8124C22.7238 31.9889 22.5773 32.1352 22.4007 32.2362C22.2241 32.3371 22.0237 32.3891 21.8203 32.3867Z"
				fill="white"/>
			<path
				d="M41.4123 54.7807C41.3151 54.7818 41.2181 54.7708 41.1236 54.7479C34.051 52.996 31.4101 45.9257 31.3027 45.6317L31.286 45.5669C31.2281 45.3628 29.809 40.5145 31.9875 37.6748C32.9861 36.3798 34.505 35.7156 36.5106 35.7156C38.3753 35.7156 39.7205 36.2953 40.6452 37.495C41.4069 38.4746 41.7116 39.6827 42.0064 40.8466C42.6257 43.2704 43.0728 44.5432 45.6467 44.6742C46.7771 44.7313 47.5197 44.0702 47.941 43.5072C49.0797 41.9724 49.2778 39.4701 48.4193 37.2612C47.3164 34.41 43.4019 29.0346 36.4999 29.0346C33.5536 29.0346 30.8465 29.9814 28.6756 31.7608C26.8787 33.2347 25.455 35.3157 24.7695 37.4546C23.4982 41.4369 25.1656 47.6967 25.1816 47.7538C25.2205 47.8995 25.2299 48.0515 25.2091 48.2009C25.1884 48.3503 25.1379 48.494 25.0608 48.6235C24.9836 48.7531 24.8813 48.8659 24.7598 48.9553C24.6383 49.0446 24.5002 49.1088 24.3536 49.144C24.0573 49.2227 23.742 49.1823 23.4752 49.0314C23.2083 48.8805 23.0112 48.631 22.9261 48.3365C22.8499 48.0509 21.069 41.3744 22.5376 36.7721C24.1373 31.7852 29.074 26.7578 36.5022 26.7578C39.9353 26.7578 43.1787 27.9248 45.8858 30.1284C47.9821 31.8423 49.6944 34.1442 50.5902 36.4454C51.729 39.3833 51.4235 42.6808 49.814 44.8349C48.7415 46.2715 47.2143 47.0226 45.5225 46.9411C41.1152 46.7202 40.323 43.6436 39.7456 41.3996C39.1515 39.0977 38.7714 37.9878 36.5022 37.9878C35.2561 37.9878 34.3808 38.3306 33.8362 39.0405C33.0935 40.0117 33.0357 41.5298 33.1179 42.6313C33.1719 43.3987 33.3021 44.1588 33.5064 44.9004C33.6877 45.3575 36.0483 51.1465 41.7017 52.5473C41.8479 52.5819 41.9856 52.6453 42.1071 52.7336C42.2285 52.8219 42.3312 52.9335 42.4092 53.0618C42.4871 53.1902 42.5388 53.3327 42.5612 53.4812C42.5836 53.6297 42.5763 53.7812 42.5396 53.9268C42.4706 54.1726 42.3231 54.3892 42.1196 54.5433C41.916 54.6975 41.6676 54.7809 41.4123 54.7807Z"
				fill="white"/>
			<path
				d="M32.334 54.2587C32.1755 54.259 32.0185 54.2274 31.8725 54.1657C31.7264 54.1041 31.5943 54.0137 31.4839 53.8999C28.6534 50.9292 27.0522 47.6073 26.4497 43.4537V43.4316C26.1115 40.6818 26.6066 36.7886 29.0327 34.112C30.8235 32.1368 33.341 31.1329 36.5021 31.1329C40.2406 31.1329 43.1786 32.8711 45.0105 36.1518C46.3397 38.5353 46.6033 40.9103 46.6101 41.0078C46.6241 41.1581 46.6082 41.3097 46.5635 41.4539C46.5187 41.5981 46.446 41.7321 46.3494 41.8481C46.2528 41.9641 46.1343 42.06 46.0006 42.1302C45.867 42.2003 45.7207 42.2434 45.5704 42.257C45.267 42.2899 44.9628 42.2022 44.7236 42.0128C44.4843 41.8234 44.3291 41.5475 44.2915 41.2447C44.0908 39.8196 43.6297 38.4437 42.931 37.1855C41.5112 34.6802 39.351 33.4066 36.4937 33.4066C34.0258 33.4066 32.0948 34.1493 30.7664 35.6156C28.8514 37.7294 28.4812 40.9857 28.744 43.1398C29.2719 46.8129 30.6834 49.7348 33.1757 52.346C33.2797 52.4542 33.3609 52.5822 33.4145 52.7224C33.468 52.8627 33.4929 53.0122 33.4875 53.1622C33.4821 53.3122 33.4465 53.4596 33.383 53.5956C33.3195 53.7317 33.2293 53.8535 33.1178 53.954C32.903 54.1487 32.6239 54.2572 32.334 54.2587Z"
				fill="white"/>
			<path
				d="M45.3737 50.9872C42.8981 50.9872 40.7935 50.3016 39.1093 48.9389C35.7257 46.2127 35.3464 41.7726 35.3297 41.5852C35.3058 41.2777 35.4051 40.9732 35.6058 40.7389C35.8064 40.5045 36.0919 40.3595 36.3995 40.3356C36.7071 40.3118 37.0115 40.4111 37.2459 40.6118C37.4802 40.8124 37.6252 41.0979 37.6491 41.4055C37.6575 41.471 37.9957 45.1029 40.6038 47.1945C42.147 48.427 44.2098 48.916 46.7516 48.6304C47.0554 48.5935 47.3614 48.6785 47.6028 48.8666C47.8442 49.0547 48.0013 49.3307 48.0397 49.6343C48.0563 49.7843 48.0429 49.9361 48.0003 50.0808C47.9576 50.2256 47.8866 50.3604 47.7913 50.4774C47.696 50.5944 47.5784 50.6912 47.4452 50.7623C47.3121 50.8333 47.1662 50.8771 47.0159 50.8912C46.4708 50.9548 45.9225 50.9868 45.3737 50.9872Z"
				fill="white"/>
			<path
				d="M47.3297 20.7164C46.3638 20.088 42.9391 18.2188 36.4996 18.2188C29.7401 18.2188 26.307 20.2838 25.5476 20.8086C25.4974 20.8394 25.4504 20.8751 25.4074 20.9152C25.4029 20.9196 25.3969 20.9223 25.3906 20.9229C25.2694 21.0287 25.1721 21.1593 25.1052 21.3057C25.0384 21.4522 25.0035 21.6112 25.0029 21.7722C25.005 21.9231 25.0369 22.0721 25.0966 22.2107C25.1564 22.3493 25.2429 22.4747 25.3513 22.5798C25.4596 22.6848 25.5876 22.7675 25.728 22.823C25.8683 22.8786 26.0182 22.9058 26.1691 22.9033C26.411 22.9032 26.647 22.829 26.8455 22.6908C26.8783 22.6664 29.833 20.4955 36.5018 20.4955C43.1707 20.4955 46.1414 22.6588 46.1734 22.6748C46.3762 22.8252 46.6225 22.9054 46.8749 22.9033C47.026 22.9056 47.176 22.8781 47.3163 22.8223C47.4567 22.7665 47.5846 22.6835 47.6929 22.5781C47.8011 22.4728 47.8874 22.347 47.9469 22.2082C48.0064 22.0694 48.0379 21.9202 48.0396 21.7691C48.0397 21.5429 47.9721 21.3218 47.8456 21.1342C47.7191 20.9466 47.5394 20.8012 47.3297 20.7164Z"
				fill="white"/>
		</svg>
	</div>
	<div *ngIf="!isFingerPrint && !errorMessage">
		<svg fill="none" height="73" viewBox="0 0 73 73" width="73" xmlns="http://www.w3.org/2000/svg">
			<circle cx="36.5" cy="36.5" fill="#0357EE" fill-opacity="0.1" r="36.5"/>
			<circle cx="36.5" cy="36.5" fill="#0361F0" r="25.5"/>
			<path
				d="M22.1665 29.3333C22.1665 27.3506 21.6675 24.7647 23.216 23.2162C24.7645 21.6677 27.3504 22.1667 29.3332 22.1667"
				stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
			<path
				d="M22.166 43.6667V47.25C22.166 48.2004 22.5435 49.1118 23.2155 49.7838C23.8876 50.4558 24.799 50.8333 25.7493 50.8333H29.3327"
				stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
			<path
				d="M43.666 22.1667H47.2493C48.1997 22.1667 49.1111 22.5442 49.7831 23.2162C50.4552 23.8882 50.8327 24.7996 50.8327 25.75V29.3333"
				stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
			<path
				d="M43.666 50.8333H47.2493C48.1997 50.8333 49.1111 50.4558 49.7831 49.7838C50.4552 49.1118 50.8327 48.2004 50.8327 47.25V43.6667"
				stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
			<path d="M31.125 32.9167H31.1429" stroke="white" stroke-linecap="round" stroke-linejoin="round"
				  stroke-width="2"/>
			<path d="M41.875 32.9167H41.8929" stroke="white" stroke-linecap="round" stroke-linejoin="round"
				  stroke-width="2"/>
			<path
				d="M32.0205 41.875C32.6044 42.4709 33.3013 42.9443 34.0704 43.2675C34.8395 43.5907 35.6654 43.7572 36.4997 43.7572C37.3339 43.7572 38.1598 43.5907 38.9289 43.2675C39.6981 42.9443 40.395 42.4709 40.9788 41.875"
				stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
		</svg>
	</div>
	<div *ngIf="errorMessage">
		<svg fill="none" height="73" viewBox="0 0 73 73" width="73" xmlns="http://www.w3.org/2000/svg">
			<circle cx="36.5" cy="36.5" fill="#E94444" fill-opacity="0.1" r="36.5"/>
			<path
				d="M37 59C24.5736 59 14.5 48.9264 14.5 36.5C14.5 24.0736 24.5736 14 37 14C49.4264 14 59.5 24.0736 59.5 36.5C59.4864 48.9208 49.4208 58.9864 37 59ZM34.75 43.25V47.75H39.25V43.25H34.75ZM34.75 25.25V38.75H39.25V25.25H34.75Z"
				fill="#E94444"/>
		</svg>
	</div>
</ng-template>
<app-kamona-dialog [icon]="iconRef">
	<div *ngIf="!errorMessage" class="text-center">
		<div>
			<div class="success-title">
				Enable Biometrics
			</div>
		</div>
		<div class="m-t-8">
			<div class="success-des">
			<span *ngIf="!isFingerPrint">
				Would you like to enable face biometrics for
				a more secure and faster login?
			</span>
				<span *ngIf="isFingerPrint">
				Would you like to enable finger print biometrics for
				a more secure and faster login?
			</span>
			</div>
		</div>
		<div class="m-t-32">
			<div class="success-divider">
			</div>
		</div>
		<div class="m-t-24 m-b-8">
			<div nz-row nzAlign="middle" nzJustify="space-between">
				<div nz-col nzSpan="12">
					<div (click)="cancelModal()"
						 class="back-btn">
						Not Now
					</div>
				</div>
				<div nz-col nzSpan="12">
					<div class="kamona-button-session">
						<app-kamona-custom-button
							(submitForm)="setUpBiometric()"
							[isBlock]="true"
							[isSubmitting]="submitting"
							[state]="'primary'"
							text="Enable Biometrics">
						</app-kamona-custom-button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="errorMessage">
		<div>
			<div class="success-title">
				Biometric Registration Failed
			</div>
			<div class="m-t-8">
				<div class="success-des">
					{{errorMessage}}
				</div>
			</div>
			<div class="m-t-16">
				<div class="success-divider">
				</div>
			</div>
			<div class="m-t-32">
				<div nz-row nzAlign="middle" nzJustify="space-between">
					<div></div>
					<div nz-row nzAlign="middle">
						<div>
							<div (click)="cancelModal()" class="back-btn">
								Dismiss
							</div>
						</div>
						<div class="m-l-32">
							<div class="button-size-157">
								<app-kamona-custom-button
									(submitForm)="setUpBiometric()"
									[isBlock]="true"
									[isSubmitting]="submitting"
									text="Retry">
								</app-kamona-custom-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</app-kamona-dialog>
